import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

const RolesTabSkeleton: React.FC = () => (
  <div className="grid grid-cols-1 lg:grid-cols-[280px_1fr] gap-4">
    <div className="space-y-2">
      {Array.from({ length: 8 }).map((_, i) => <Skeleton key={i} className="h-9 w-full" />)}
    </div>
    <div className="space-y-3">
      <Skeleton className="h-7 w-48" />
      {Array.from({ length: 6 }).map((_, i) => <Skeleton key={i} className="h-9 w-full" />)}
    </div>
  </div>
)

export default RolesTabSkeleton
